// @flow
/* eslint-disable react/no-did-mount-set-state */
import axios from 'axios';
import * as React from 'react';
import API from 'lib/RemindAPI';
import toPairs from 'lodash/toPairs';
import dataURItoBlob from 'data-uri-to-blob';
import type { PickFile } from './Picker.jsx';

type Props = {
  file: PickFile,
  private?: boolean,
  children: Function,
  onUploadSuccess?: Function,
  onUploadSuccess2?: Function,
};

type State = {
  url?: string,
  progress?: number,
};

export function buildForm(fields: *, blob: File) {
  const form = new FormData();
  const data = [...toPairs(fields), ['file', blob]];

  data.forEach(pair => form.append(...pair));

  return form;
}

class Uploader extends React.Component<Props, State> {
  state: State = {};

  componentDidMount() {
    this.uploadFile(this.props.file);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.file.dataURI !== this.props.file.dataURI) {
      this.uploadFile(this.props.file);
    }
  }

  async uploadFile(file: PickFile) {
    this.setState({ progress: 0, url: undefined });

    const data = await API.request('/files', 'POST', {
      file: { name: file.name },
      private: !!this.props.private,
    });

    const blob = dataURItoBlob(file.dataURI);
    const form = buildForm(data.fields, blob);

    await axios.post(data.upload_url, form, {
      onUploadProgress: progressEvent => {
        this.setState({ progress: (progressEvent.loaded / progressEvent.total) * 100 });
      },
    });

    const url = `${data.upload_url}/${data.id}/${file.name}`;

    this.setState({ url });

    if (this.props.onUploadSuccess) {
      this.props.onUploadSuccess(data);
    }

    if (this.props.onUploadSuccess2) {
      this.props.onUploadSuccess2({ data, url });
    }
  }

  render() {
    return this.props.children({
      progress: this.state.progress,
      url: this.state.url,
    });
  }
}

export default Uploader;
